export enum LanguageType {
  Polish = 'pl',
  English = 'en',
  Russian = 'ru',
  Ukrainian = 'ua',
  'pl' = Polish,
  'en' = English,
  'ru' = Russian,
  'ua' = Ukrainian
}
